import styled from 'styled-components'

export const StyledUserInviteErrorView = styled.div`
  p {
    font-size: ${props => props.theme.font.medium};
    margin-bottom: ${props => props.theme.spacing.medium};
  }
`
